import React, { useState, useEffect, useRef, useContext } from 'react';

import FlyUpModal from '../FlyUpModal';
import './ThreeDModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../ModalOverlay';
import ThreeViewer from 'web-store-modules/packages/modal-media/lib/three-viewer/ThreeViewer';

const isMobile = isMobileDevice();
const productImageStyle = {
	display: 'flex',
	minWidth: '100%',
	minHeight: '100%',
	objectFit: 'contain',
	transition: 'all 500ms',
	padding: '0 0.5em',
	transform: `translate(0px, 0px)`,
};

const ThreeDModal = ({ modalContent, onModalHidden }) => {
	const { body } = modalContent;

	const modalRef = useRef();

	useEffect(() => {
		addListeners();
		return () => {
			removeListeners();
		};
	}, []);

	const addListeners = () => {
		if (isMobile) {
			window.addEventListener('touchend', handleModalClose);
		} else {
			window.addEventListener('click', handleModalClose);
		}
	};

	const removeListeners = () => {
		if (isMobile) {
			window.removeEventListener('touchend', handleModalClose);
		} else {
			window.removeEventListener('click', handleModalClose);
		}
	};

	const handleModalClose = (e) => {
		if (modalRef && modalRef.current.contains(e.target)) {
			return;
		}
	};

	const renderModalContent = () => {
		return (
			<div
				className='text-modal-content'
				style={{ textAlign: 'center' }}
				ref={modalRef}>
				<ThreeViewer
					gltfModel={body}
					usdzModel={body}
					arEnabled={true}
					threeStyle={productImageStyle}
					setIsUserInteracting={() => {}}
				/>
			</div>
		);
	};

	return (
		//Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
		<FlyUpModal
			extraClassName={'text-modal-container'}
			onModalHidden={onModalHidden}
			isOpaque
			textPopup
			hideCloseIcon
			isImageLoaded>
			<ModalOverlay />
			{renderModalContent()}
		</FlyUpModal>
	);
};

export default ThreeDModal;
